/**
 * Copy production data into the test environment on demand (#3462).
 * Test environments only; staff-api answers 404 in production.
 */

import { api } from '@/lib/api';
import type { GithubErrorSummary } from './releaseApproval';

export type RefreshBlockReason =
  | 'not_configured'
  | 'no_permission'
  | 'refresh_in_progress'
  | 'github_permission_missing'
  | 'github_unavailable';

export interface RefreshRun {
  status: 'queued' | 'in_progress' | 'success' | 'failure';
  /** Who pressed the button; null for the nightly schedule. */
  requestedBy: string | null;
  startedAt: string;
  finishedAt: string | null;
  url: string;
}

export interface TestEnvironmentState {
  restore: { restoredAt: string | null; backupStoppedAt: string | null } | null;
  latestRun: RefreshRun | null;
  refreshers: { userId: string; name: string }[];
  canRefresh: boolean;
  blockedReason: RefreshBlockReason | null;
  githubError: GithubErrorSummary | null;
}

export function getTestEnvironment(): Promise<TestEnvironmentState> {
  return api.get<TestEnvironmentState>('/test-environment');
}

export function refreshTestData(): Promise<{ requested: boolean }> {
  return api.post<{ requested: boolean }>('/test-environment/refresh');
}
